import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { PAYMENT_METHOD_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import { AddPaymentCardRequest, AddPaymentCardResponse } from './types';

export function useAddCardMutationApi() {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseMutation<AddPaymentCardRequest, AddPaymentCardResponse>(
    {
      url: `${PAYMENT_METHOD_ROOT_ENDPOINT.replace(
        ':customerId',
        workspaceId
      )}`,
      method: HttpMethod.post,
    },
    {
      onSuccess: (data) => {
        window.location.href = data.url;
      },
    }
  );
}
